import fetchApi from "../fetchApi";
export const ExportVoidOrders = async ({
  sell_order_id = "",
  dateFrom = "",
  dateTo = "",
}) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({
      sell_order_id,
      created_on_gte: dateFrom,
      created_on_lte: dateTo,
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/void-cards/report-csv`, options);
};